export {isDev, log};
function isDev() {
    return window.location.host.indexOf("localhost")>=0 ? true : false;
}
function log(...attr) {
    if (isDev()) {
        console.log(...attr);
    }
}